export default __webpack_public_path__ + "static/media/ic-personal.c47d0927.svg";